export const FORM_EDITOR_RETURN_FALLBACK = '/scribe/my-forms';

/**
 * Resolves a safe in-app path for leaving the form editor (open-redirect safe).
 * Falls back to {@link FORM_EDITOR_RETURN_FALLBACK} when invalid.
 */
export function getSafeFormEditorReturnPath(path: string | null | undefined): string {
  if (path == null || path === '') {
    return FORM_EDITOR_RETURN_FALLBACK;
  }

  const trimmed = path.trim();
  if (!trimmed.startsWith('/')) {
    return FORM_EDITOR_RETURN_FALLBACK;
  }
  if (trimmed.startsWith('//')) {
    return FORM_EDITOR_RETURN_FALLBACK;
  }
  if (trimmed.includes('://')) {
    return FORM_EDITOR_RETURN_FALLBACK;
  }

  const pathname = trimmed.split('?')[0]?.split('#')[0] ?? '';
  if (pathname === '/scribe/form-editor' || pathname.startsWith('/scribe/form-editor/')) {
    return FORM_EDITOR_RETURN_FALLBACK;
  }

  return trimmed;
}

/**
 * True when leaving the form editor should land on My Templates such that we
 * should select the Forms (form templates) tab.
 */
export function shouldSelectFormsTabAfterLeavingFormEditor(target: string): boolean {
  let pathname = target.trim().split('?')[0]?.split('#')[0] ?? '';
  if (pathname.length > 1 && pathname.endsWith('/')) {
    pathname = pathname.slice(0, -1);
  }
  return pathname === '/scribe/my-templates';
}
